<section class="sps-liste">

  <!-- KOPF -->
  <header class="kopf">
    <button mat-icon-button type="button" (click)="zurUebersicht()" matTooltip="Zurück zu den SPS-Listen">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <div class="kopf-titel">
      <h1>
        <mat-icon class="kopf-icon">{{ typInfo.icon }}</mat-icon>
        {{ liste?.name || typInfo.titel }}
      </h1>
      <app-sps-breadcrumbs [teile]="[
        { text: 'Projekt', route: ['/projekte', projektId], icon: 'folder' },
        { text: 'SPS-Listen', route: ['/projekte', projektId, 'sps-listen'] },
        { text: liste?.name || typInfo.titel }
      ]"></app-sps-breadcrumbs>
    </div>

    <div class="kopf-aktionen">
      

      <button mat-stroked-button color="primary" type="button" (click)="zurSpsPruefung()">
        <mat-icon>fact_check</mat-icon>
        SPS-Prüfung
      </button>

      <ng-container *ngIf="kannVerwalten && liste">
        <button mat-icon-button type="button" class="listen-mehr-aktionen"
          [matMenuTriggerFor]="listenAktionenMenu" [disabled]="loescht"
          matTooltip="Weitere Listenaktionen" aria-label="Weitere Listenaktionen öffnen">
          <mat-spinner diameter="20" *ngIf="loescht"></mat-spinner>
          <mat-icon *ngIf="!loescht">more_vert</mat-icon>
        </button>
        <mat-menu #listenAktionenMenu="matMenu" xPosition="before">
          <button mat-menu-item type="button" (click)="listeAktualisieren()" [disabled]="loescht"
            matTooltip="Neuere Excel-Version hochladen; der bestehende Prüfstatus bleibt erhalten">
            <mat-icon>sync</mat-icon>
            <span>Liste aktualisieren</span>
          </button>
          <button mat-menu-item type="button" class="listen-loeschen-aktion" (click)="listeLoeschen()"
            [disabled]="loescht">
            <mat-icon color="warn">delete_outline</mat-icon>
            <span>Liste löschen</span>
          </button>
        </mat-menu>
      </ng-container>
    </div>
  </header>

  <!-- FEHLER -->
  <div class="fehlermeldung" *ngIf="fehler">
    <mat-icon>error_outline</mat-icon>
    <span>{{ fehler }}</span>
    <button mat-button type="button" (click)="aktualisieren()">Erneut laden</button>
  </div>

  <!-- LADEN DER LISTE -->
  <div class="laden" *ngIf="laedtListe">
    <mat-spinner diameter="40"></mat-spinner>
  </div>

  <!-- OFFLINE-HINWEIS -->
  <div class="sps-offline-banner" *ngIf="istOffline && liste && !laedtListe">
    <mat-icon>cloud_off</mat-icon>
    <span>
      Offline-Daten · Stand {{ standUtc | date:'dd.MM.yyyy HH:mm' }} ·
      Zeilen und Signale lassen sich ansehen und prüfen. Listenupdate und Löschen brauchen eine Verbindung.
    </span>
  </div>

  <ng-container *ngIf="liste && !laedtListe">

    <!-- META -->
    <mat-card class="sps-card meta-card">
      <mat-card-content>
        <div class="meta-zeile">
          <span class="chip chip-typ">
            <mat-icon inline>{{ typInfo.icon }}</mat-icon>
            {{ typInfo.titel }}
          </span>

          <span class="chip">{{ liste.eintraegeAnzahl }} Einträge</span>

          <span class="meta-item" [matTooltip]="liste.dateiName">
            <mat-icon>description</mat-icon>
            <span class="meta-text">{{ liste.dateiName }}</span>
          </span>

          <span class="meta-item" *ngIf="liste.tabellenblatt">
            <mat-icon>table_chart</mat-icon>
            <span>Blatt „{{ liste.tabellenblatt }}“</span>
          </span>

          <span class="meta-item">
            <mat-icon>event</mat-icon>
            <span>Importiert {{ liste.importiertAmUtc | date:'dd.MM.yyyy HH:mm' }}<ng-container
                *ngIf="liste.importiertVon"> · {{ liste.importiertVon }}</ng-container></span>
          </span>

          <span class="meta-item" *ngIf="liste.aktualisiertAmUtc"
            [matTooltip]="liste.aktualisierungen + ' Listenupdate(s) mit einer neueren Excel-Version'">
            <mat-icon>sync</mat-icon>
            <span>Aktualisiert {{ liste.aktualisiertAmUtc | date:'dd.MM.yyyy HH:mm' }}<ng-container
                *ngIf="liste.aktualisiertVon"> · {{ liste.aktualisiertVon }}</ng-container></span>
          </span>

          <span class="meta-item" *ngIf="liste.anlagenteilSpalte"
            matTooltip="Anlagenteile werden aus dieser Spalte übernommen – exakt der Zellwert">
            <mat-icon>account_tree</mat-icon>
            <span>Anlagenteile aus „{{ liste.anlagenteilSpalte }}“</span>
          </span>

          <span class="meta-item" *ngIf="(liste.eintraegeAusPruefungEntfernt || 0) > 0"
            matTooltip="Zeilen, die bewusst nur aus der SPS-Prüfung entfernt wurden – sie bleiben in der Liste und werden nicht erneut geprüft">
            <mat-icon>visibility_off</mat-icon>
            <span>{{ liste.eintraegeAusPruefungEntfernt }} aus Prüfung entfernt</span>
          </span>

          <span class="meta-item" *ngIf="liste.signaleUngeklaert > 0"
            matTooltip="Zeilen, deren Zuordnung zu einem gemeinsamen Signal noch zu klären ist">
            <mat-icon class="warn">help_outline</mat-icon>
            <span>{{ liste.signaleUngeklaert }} ungeklärte Zuordnung{{ liste.signaleUngeklaert === 1 ? '' : 'en'
              }}</span>
          </span>
        </div>


      </mat-card-content>
    </mat-card>

    <!-- TABELLE -->
    <mat-card class="sps-card">
      <mat-card-content>


        <!-- RICHTUNGSFILTER -->
        <div class="listen-richtungs-tabs">

          <button type="button" [class.aktiv]="filter.richtung === null" (click)="richtungSetzen(null)">
            <mat-icon>list</mat-icon>
            Alle
          </button>

          <button type="button" [class.aktiv]="filter.richtung === 'Eingang'" (click)="richtungSetzen('Eingang')">
            <mat-icon>input</mat-icon>
            Eingänge
          </button>

          <button type="button" [class.aktiv]="filter.richtung === 'Ausgang'" (click)="richtungSetzen('Ausgang')">
            <mat-icon>output</mat-icon>
            Ausgänge
          </button>

          <button type="button" [class.aktiv]="filter.richtung === 'Unbekannt'" (click)="richtungSetzen('Unbekannt')">
            <mat-icon>help_outline</mat-icon>
            Unbekannt
          </button>

        </div>

        <!-- FILTERLEISTE -->
        <div class="listen-filter">

          <!-- Allgemeine Suche -->
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-suche">

            <mat-label>Suchen</mat-label>

            <input matInput [(ngModel)]="suche" (ngModelChange)="filter.suche = $event; textGeaendert()"
              (keyup.enter)="sucheAnwenden()" placeholder="Signal, Adresse, BMK, Beschreibung, Station, Anschluss, Kanal, Ort, Datentyp">

            <button mat-icon-button matSuffix type="button" *ngIf="suche" (click)="sucheLeeren()"
              matTooltip="Suche leeren">
              <mat-icon>close</mat-icon>
            </button>

            <mat-icon matSuffix *ngIf="!suche">search</mat-icon>

          </mat-form-field>

          <!-- Prüfstatus -->
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-status">

            <mat-label>Prüfstatus</mat-label>

            <mat-select [value]="filter.status" (selectionChange)="statusSetzen($event.value)">

              <mat-option [value]="null">Alle</mat-option>

              <mat-option *ngFor="let o of statusOptionen" [value]="o.wert">
                {{ o.text }}
              </mat-option>

            </mat-select>
          </mat-form-field>

          <!--
            Anlagenteil – listenbezogen: nur Anlagenteile, die in DIESER Liste
            vorkommen (serverseitig über alle Zeilen); „Ohne“ nur, wenn es solche
            Zeilen gibt. Die Zuordnungsauswahl (alle des Projekts) ist davon getrennt.
          -->
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-anlagenteil"
            *ngIf="zeigeAnlagenteilFilter">

            <mat-label>Anlagenteil</mat-label>

            <mat-select [value]="anlagenteilAuswahl" (selectionChange)="anlagenteilSetzen($event.value)">

              <mat-option [value]="null">Alle Anlagenteile</mat-option>

              <mat-option *ngIf="zeigeOhneAnlagenteil" value="ohne">
                Ohne Anlagenteil ({{ anlagenteilOptionen.ohneAnlagenteil }})
              </mat-option>

              <mat-option *ngIf="anlagenteilAuswahlFehlt" [value]="filter.anlagenteilId">
                Anlagenteil #{{ filter.anlagenteilId }} (nicht in dieser Liste)
              </mat-option>

              <mat-option *ngFor="let a of anlagenteilOptionen.anlagenteile" [value]="a.anlagenteilId">
                {{ a.name }} ({{ a.anzahl }})
              </mat-option>

            </mat-select>
          </mat-form-field>

          <!-- Sortierung -->
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="filter-sortierung">

            <mat-label>Sortierung</mat-label>

            <mat-select [value]="filter.sortierung" (selectionChange)="sortierungSetzen($event.value)">

              <mat-option *ngFor="let s of sortierungen" [value]="s.wert">
                {{ s.text }}
              </mat-option>

            </mat-select>
          </mat-form-field>

          <!-- Nur offene -->
          <mat-slide-toggle [checked]="filter.nurOffen" (change)="nurOffeneSetzen($event.checked)"
            matTooltip="Nur ungeprüfte und nicht in Ordnung befundene Einträge">

            Nur offene
          </mat-slide-toggle>

          <!-- Erweiterte Filter -->
          <button mat-button type="button" (click)="erweitertUmschalten()">
            <mat-icon>
              {{ erweitert ? 'expand_less' : 'tune' }}
            </mat-icon>
            Felder
          </button>

          <!-- Zurücksetzen -->
          <button mat-stroked-button type="button" [disabled]="!filterAktiv" (click)="filterZuruecksetzen()">
            <mat-icon>filter_alt_off</mat-icon>
            Zurücksetzen
          </button>

        </div>

        <!-- ERWEITERTE FELDFILTER -->
        <div class="listen-filter listen-filter-erweitert" *ngIf="erweitert">

          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Signalname</mat-label>
            <input matInput [(ngModel)]="filter.name" (ngModelChange)="textGeaendert()">
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>SPS-Adresse</mat-label>
            <input matInput [(ngModel)]="filter.adresse" (ngModelChange)="textGeaendert()" placeholder="z. B. I0.0">
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>BMK</mat-label>
            <input matInput [(ngModel)]="filter.bmk" (ngModelChange)="textGeaendert()">
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Beschreibung</mat-label>
            <input matInput [(ngModel)]="filter.beschreibung" (ngModelChange)="textGeaendert()">
          </mat-form-field>

          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-label>Station / Pfad</mat-label>
            <input matInput [(ngModel)]="filter.station" (ngModelChange)="textGeaendert()">
          </mat-form-field>

          <!-- Nur SPS-Zuordnungsliste -->
          <ng-container *ngIf="liste?.listenTyp === 'SpsZuordnungsliste'">

            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>Anschluss</mat-label>
              <input matInput [(ngModel)]="filter.anschluss" (ngModelChange)="textGeaendert()">
            </mat-form-field>

            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>Kanal</mat-label>
              <input matInput [(ngModel)]="filter.kanal" (ngModelChange)="textGeaendert()">
            </mat-form-field>

            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>Ort</mat-label>
              <input matInput [(ngModel)]="filter.ort" (ngModelChange)="textGeaendert()">
            </mat-form-field>

            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <mat-label>Platzierung</mat-label>
              <input matInput [(ngModel)]="filter.platzierung" (ngModelChange)="textGeaendert()">
            </mat-form-field>

          </ng-container>

          <!-- Nur PLC-Tag-Liste -->
          <mat-form-field *ngIf="liste?.listenTyp === 'PlcTagListe'" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Datentyp</mat-label>
            <input matInput [(ngModel)]="filter.datenTyp" (ngModelChange)="textGeaendert()" placeholder="z. B. Bool">
          </mat-form-field>

        </div>

        <!-- SPALTENANSICHT UND TREFFERANZAHL -->
        <div class="werkzeuge">

          <mat-button-toggle-group [ngModel]="ansicht" (ngModelChange)="ansichtGeaendert($event)" class="ansicht" aria-label="Spaltenansicht">

            <mat-button-toggle value="standard">
              Standard
            </mat-button-toggle>

            <mat-button-toggle value="original" [disabled]="originalSpalten.length === 0">
              Alle Excel-Spalten ({{ originalSpalten.length }})
            </mat-button-toggle>

          </mat-button-toggle-group>

          <span class="treffer" *ngIf="seite">
            {{ seite.gesamt }}
            {{ filterAktiv ? 'gefilterte Einträge' : 'Einträge' }}
          </span>

        </div>


        <mat-progress-bar mode="indeterminate" *ngIf="laedtEintraege"></mat-progress-bar>

        <!-- SCROLLBARE TABELLE -->
        <div class="tabellen-scroll" [class.laedt]="laedtEintraege">
          <table class="eintraege-tabelle">
            <thead>
              <tr>
                <th class="sp-zeile">Zeile</th>
                <th *ngFor="let s of spalten; trackBy: trackBySpalte" [class]="s.klasse || ''">{{ s.titel }}</th>
                <th class="sp-status">Prüfstatus</th>
                <th class="sp-aktion"></th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let e of seite?.eintraege ?? []; trackBy: trackByEintrag"
                [class.klickbar]="e.signalId != null" [class.ungeklaert]="e.zuordnungsStatus === 'Ungeklaert'"
                (click)="oeffneSignal(e)" (keydown.enter)="oeffneSignal(e)"
                [attr.tabindex]="e.signalId != null ? 0 : null">

                <td class="sp-zeile">{{ e.excelZeile }}</td>

                <td *ngFor="let s of spalten; trackBy: trackBySpalte" [class]="s.klasse || ''">

                  <!-- Anlagenteil als Chip – kein leerer Chip, wenn die Zeile keinen hat -->
                  <ng-container *ngIf="s.schluessel === 'anlagenteil'; else textZelle">
                    <span class="anlagenteil-chip" *ngIf="e.anlagenteilName"
                      [class.anlagenteil-chip--uebernommen]="e.anlagenteilUebernommen"
                      [matTooltip]="e.anlagenteilUebernommen
                        ? 'Anlagenteil über das gemeinsame Signal aus der anderen SPS-Liste übernommen'
                        : 'Anlagenteil aus der Spalte „' + (liste?.anlagenteilSpalte || 'Ort') + '“ dieser Liste'">
                      <mat-icon inline>account_tree</mat-icon>
                      <span>{{ e.anlagenteilName }}</span>
                    </span>
                    <span class="zelle" *ngIf="!e.anlagenteilName">–</span>
                  </ng-container>

                  <ng-template #textZelle>
                    <span class="zelle" [matTooltip]="s.wert(e)" matTooltipShowDelay="400"
                      [matTooltipDisabled]="s.wert(e).length < 24">
                      {{ s.wert(e) || '–' }}
                    </span>
                  </ng-template>

                </td>

                <td class="sp-status">
                  <span class="status-badge" [ngClass]="statusOption(e.pruefstatus).klasse" *ngIf="e.signalId != null"
                    [matTooltip]="e.zuordnungsStatus === 'Ungeklaert' ? 'Zuordnung zum Signal noch ungeklärt: ' + (e.zuordnungsGrund || '') : (e.zuordnungsGrund || '')">
                    <mat-icon inline>{{ statusOption(e.pruefstatus).icon }}</mat-icon>
                    {{ statusOption(e.pruefstatus).text }}
                  </span>
                  <span class="kein-signal" *ngIf="e.signalId == null && e.ausPruefungEntferntAmUtc"
                    [matTooltip]="'Bewusst aus der SPS-Prüfung entfernt am ' + (e.ausPruefungEntferntAmUtc | date:'dd.MM.yyyy HH:mm') + (e.ausPruefungEntferntVon ? ' von ' + e.ausPruefungEntferntVon : '') + ' – wird nicht erneut geprüft'">
                    <mat-icon inline>visibility_off</mat-icon> aus Prüfung entfernt
                  </span>
                  <span class="kein-signal" *ngIf="e.signalId == null && !e.ausPruefungEntferntAmUtc">kein Signal</span>
                </td>

                <td class="sp-aktion" (click)="$event.stopPropagation()" (keydown.enter)="$event.stopPropagation()">
                  <button mat-icon-button color="warn" type="button" *ngIf="kannVerwalten" [disabled]="wirdGeloescht(e)"
                    (click)="eintragLoeschen(e, $event)" matTooltip="Diesen Eintrag löschen">
                    <mat-spinner diameter="18" *ngIf="wirdGeloescht(e)"></mat-spinner>
                    <mat-icon *ngIf="!wirdGeloescht(e)">delete_outline</mat-icon>
                  </button>
                </td>

              </tr>
            </tbody>
          </table>

          <p class="leer" *ngIf="!laedtEintraege && seite && seite.eintraege.length === 0">
            <ng-container *ngIf="aktiveSuche">Keine Einträge für „{{ aktiveSuche }}“.</ng-container>
            <ng-container *ngIf="!aktiveSuche">Diese Liste enthält keine Einträge.</ng-container>
          </p>
        </div>

        <!-- PAGINATION (serverseitig) -->
        <mat-paginator *ngIf="seite" [length]="seite.gesamt" [pageIndex]="aktuelleSeite - 1" [pageSize]="seitenGroesse"
          [pageSizeOptions]="seitenGroessen" [showFirstLastButtons]="true" [disabled]="laedtEintraege"
          (page)="seiteGewechselt($event)">
        </mat-paginator>

      </mat-card-content>
    </mat-card>

  </ng-container>

</section>